import script from "./fault-submit-success.vue?vue&type=script&lang=ts&setup=true"
export * from "./fault-submit-success.vue?vue&type=script&lang=ts&setup=true"

import "./fault-submit-success.vue?vue&type=style&index=0&id=5c342fb0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c342fb0"]])

export default __exports__